import type { Dispatch } from "@reduxjs/toolkit";

export const GET_TEAM_CONTRACTS = "GET_TEAM_CONTRACTS";
export const GET_TEAM_CONTRACTS_ERROR = "GET_TEAM_CONTRACTS_ERROR";
export const GET_TEAM_CONTRACTS_SUCCESS = "GET_TEAM_CONTRACTS_SUCCESS";

export function getTeamContracts() {
  return (dispatch: Dispatch) => {
    dispatch({
      type: GET_TEAM_CONTRACTS,
    });
  };
}
